module.exports = __webpack_public_path__ + "files/d54bf33e22a1f3b78619868bc7266f56.png";